export default __webpack_public_path__ + "static/media/logo_tecno.2bac645d.png";